// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Tab_navLink__22pOV","navLinkActive":"Tab_navLinkActive__i71ti"};